// extracted by mini-css-extract-plugin
export default {"ScreenSMMax":"(max-width: 991px)","collageContainer":"G564094","collageItem":"G81292c","collageImage":"Gd0a409","emptyItem":"G9f3224"};